// extracted by css-extract-rspack-plugin
export default {"virtualizedDiffRow":"PullRequestVirtualizedDiffRow-module__virtualizedDiffRow__LvCLz"};